import type { ComponentType } from 'react'
import { frontmatter as fm1 } from './your-hsa-is-a-tax-free-emergency-fund.mdx'
import { frontmatter as fm2 } from './hsa-triple-tax-advantage-explained.mdx'

export interface BlogPostMeta {
  title: string
  description: string
  date: string       // "YYYY-MM-DD"
  slug: string
  author: string
  tags: string[]
  readingTime: number // minutes, set in frontmatter
}

const allPosts: BlogPostMeta[] = [
  fm1 as BlogPostMeta,
  fm2 as BlogPostMeta,
]

/** All posts sorted newest first. */
export const posts: BlogPostMeta[] = allPosts.sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
)

/** Lazy loaders per slug — enables code-splitting per post. */
export const postComponents: Record<string, () => Promise<{ default: ComponentType }>> = {
  [fm1.slug]: () => import('./your-hsa-is-a-tax-free-emergency-fund.mdx'),
  [fm2.slug]: () => import('./hsa-triple-tax-advantage-explained.mdx'),
}
